import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import Datasets from '../data/Datasets';

export default class AdminDatasets extends React.Component {
  static propTypes = {
    accounts: PropTypes.object.isRequired,
    dataSetsSummary: PropTypes.object.isRequired,
    enableVersionFunction: PropTypes.func.isRequired,
    fetchDatasetRecordCountFunction: PropTypes.func.isRequired,
    fetchFieldsetsByIdFunction: PropTypes.func.isRequired,
    fetchVersionsFunction: PropTypes.func.isRequired,
    fieldSetsSummary: PropTypes.object.isRequired,
    isAdminPage: PropTypes.bool.isRequired,
    recordsSummary: PropTypes.object.isRequired,
    resetBooleansAction: PropTypes.func.isRequired,
    versionsSummary: PropTypes.object.isRequired,
  };

  state = {
    accordionsOpen: [],
    filtered: false,
  };

  toggleAccordion = newAccordionId => () => {
    const { accordionsOpen } = this.state;
    const location = accordionsOpen.indexOf(newAccordionId);

    // Only one accordion should be open at a time
    if (location >= 0) {
      this.state.accordionsOpen = [];
      this.setState({
        accordionsOpen: this.state.accordionsOpen,
      });
    } else {
      this.state.accordionsOpen = [newAccordionId];
      this.setState({
        accordionsOpen: this.state.accordionsOpen,
      });
    }
  };

  toggleFilter = () => {
    const { filtered } = this.state;

    if (filtered) {
      this.setState({
        filtered: false,
      });
    } else {
      this.setState({
        filtered: true,
      });
    }
  };

  renderAccounts = (account, isPending) => {
    const { accordionsOpen } = this.state;
    const { resetBooleansAction } = this.props;

    const isOpen = accordionsOpen.reduce((l, r) => l || r === account.companyName, false);

    return (
      <div key={account.id} className="card card-block no-padding">
        <div className="panel panel-default" key={account.id}>
          <div className="panel-heading" role="tab" id={account.companyName}>
            <div className="panel-title">
              <div
                data-toggle="collapse"
                data-parent="#accordion"
                role="button"
                tabIndex={0}
                onClick={this.toggleAccordion(account.companyName)}
                aria-expanded={isOpen}
                aria-controls={account.id}
                className={isOpen ? 'collapsed single-info panel-active' : 'collapsed single-info'}
              >
                <strong>{account.companyName} </strong>
                <span className="pull-right">
                  {isPending ? this.renderPendingStatus() : this.renderUpdatedStatus()}
                </span>
              </div>
            </div>
          </div>
          <div
            id="collapseOne"
            className={isOpen ? 'panel-collapse collapse in' : 'panel-collapse collapse'}
            role="tabpanel"
            aria-labelledby={account.companyName}
            aria-expanded={isOpen}
          >
            <div className="row">
              <div className="col-md-12">
                <span className="pull-right">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      resetBooleansAction(account.id);
                    }}
                  >
                    New List
                  </button>
                  <Link to={`/orders/create/1/${account.id}`} className="btn btn-primary" disabled>
                    New Order
                  </Link>
                </span>
              </div>
            </div>
            <div className="pre-scrollable">{isOpen ? this.renderAccountInfo(account) : null}</div>
          </div>
        </div>
      </div>
    );
  };

  renderPendingStatus = () => (
    <span>
      <i className="fa fa-ellipsis-h" style={{ color: 'rgb(231,171,0)' }} />
      &nbsp;{' '}
      <weak>
        <i>Customer Datasets Need to be Updated</i>
      </weak>
    </span>
  );

  renderUpdatedStatus = () => (
    <span>
      <i className="fa fa-check-circle" style={{ color: 'rgb(0,199,123)' }} />
      &nbsp;
      <weak>
        <i>All Datasets Up to Date</i>
      </weak>
    </span>
  );

  renderAccountInfo = account => {
    const {
      dataSetsSummary,
      enableVersionFunction,
      fetchDatasetRecordCountFunction,
      fetchFieldsetsByIdFunction,
      fetchVersionsFunction,
      fieldSetsSummary,
      isAdminPage,
      recordsSummary,
      versionsSummary,
    } = this.props;
    const accountDatasets = dataSetsSummary.get(account.id);

    return (
      <div className="container">
        {accountDatasets === undefined || accountDatasets.size === 0 ? (
          <p>There are no datasets currently associated with this account </p>
        ) : (
          <Datasets
            accountId={account.id}
            dataSets={accountDatasets}
            enableVersionFunction={enableVersionFunction}
            fetchDatasetRecordCountFunction={fetchDatasetRecordCountFunction}
            fetchFieldsetsByIdFunction={fetchFieldsetsByIdFunction}
            fetchVersionsFunction={fetchVersionsFunction}
            fieldSetsSummary={fieldSetsSummary}
            isAdmin
            isAdminPage={isAdminPage}
            recordsSummary={recordsSummary}
            versionsSummary={versionsSummary}
          />
        )}
      </div>
    );
  };

  render() {
    const { filtered } = this.state;
    const { accounts, dataSetsSummary } = this.props;

    return (
      <div>
        <table className="table admin-account-datasets">
          <thead>
            <tr>
              <th>
                Click on any account or dataset for more information:
                <span className="pull-right">
                  <button className="btn btn-primary" onClick={this.toggleFilter}>
                    {filtered ? 'Show All Accounts' : 'Only Show Accounts that need Updates'}
                  </button>
                </span>
              </th>
            </tr>
          </thead>
          <tbody />
        </table>
        <div id="accordion" role="tablist" aria-multiselectable="true">
          {accounts.valueSeq().map(account => {
            let isPending = false;
            if (dataSetsSummary.get(account.id) !== undefined) {
              isPending = dataSetsSummary
                .get(account.id)
                .reduce((l, r) => l || r.status === 0, false);
            } else {
              isPending = false;
            }

            if (filtered) {
              if (!isPending) {
                return null;
              }
              return this.renderAccounts(account, isPending);
            }
            return this.renderAccounts(account, isPending);
          })}
        </div>
      </div>
    );
  }
}
